import { getSalaryTableConfig } from './getSalaryTableConfig';
import { READ_ONLY_SALARY_FIELDS } from './readOnlySalaryFields';

export { getSalaryTableConfig, READ_ONLY_SALARY_FIELDS };
